import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "timeline",
  "use": "timeline-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"timeline\">\n<path d=\"M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,2.1c3.3,0,5.9,2.6,5.9,5.9s-2.6,5.9-5.9,5.9S2.1,11.3,2.1,8\n\tS4.7,2.1,8,2.1z M8,3.5c-0.6,0-1,0.5-1,1.1V8c0,0.3,0.1,0.5,0.3,0.7l1.4,1.4c0.3,0.3,0.7,0.4,1,0.3c0.4-0.1,0.7-0.4,0.7-0.7\n\tc0.1-0.4,0-0.8-0.3-1L9,7.6v-3C9,4.2,8.9,4,8.7,3.8C8.5,3.6,8.3,3.5,8,3.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol